import React, { useEffect, useState } from "react";
import {
    Route as ReactDOMRoute,
    RouteProps as ReactDOMRouteProps,
    Redirect,
} from "react-router-dom";

import { Modal } from "react-bootstrap";
import { useUserInfor } from "../Context/User/index";
import Loading from "../Components/Loding";
import { ACESSOS } from "./Acessos";
import { useStorage } from "../hooks/useStorage";

interface RouteProps extends ReactDOMRouteProps {
    idTela?: number;
    idModulo?: number;
    isPrivate?: boolean;
    component: React.ComponentType;
}

const PrivatedRoute: React.FC<RouteProps> = ({
    idTela,
    idModulo,
    isPrivate = false,
    component: Component,
    ...rest
}) => {
    const { UserInfor, OrgInfor } = useUserInfor();
    const [telas, setTelas] = useState<boolean>(true);
    const [show, setShow] = useState<boolean>(true);

    const loginRoute = useStorage<boolean>("DEFAULT_LOGIN_ONLY_SSO")[0]
        ? "/sso"
        : "/login";

    const handleClose = () => {
        setShow(false);
    };
    useEffect(() => {
        setTelas(
            UserInfor.TELAS
                ? UserInfor.TELAS.find((tela) => tela.ID_TELA === idTela) !==
                      undefined
                : false
        );
        setShow(true);
    }, [idModulo, idTela, UserInfor.TELAS]);

    return UserInfor.TELAS || !localStorage.getItem("@token") ? (
        <ReactDOMRoute
            {...rest}
            render={({ location }) => {
                if (isPrivate !== !!localStorage.getItem("@token")) {
                    return (
                        <Redirect
                            to={{
                                pathname: isPrivate ? loginRoute : "/Geral",
                                state: { from: location },
                            }}
                        />
                    );
                }
                if (
                    idModulo &&
                    OrgInfor.MODULOS?.find(
                        (mod) => mod.ID_MODULO === idModulo
                    ) === undefined
                ) {
                    let Modulo = "Geral";
                    switch (idModulo) {
                        case ACESSOS.COBRANCA.ID_MODULO:
                            Modulo = "Cobranca";
                            break;
                        case ACESSOS.ATENDIMENTO.ID_MODULO:
                            Modulo = "Atendimento";
                            break;
                        case ACESSOS.ASSISTENCIA.ID_MODULO:
                            Modulo = "AssistenciaTecnica";
                            break;
                        case ACESSOS.VENDAS.ID_MODULO:
                            Modulo = "Vendas";
                            break;
                        case ACESSOS.REPASSE.ID_MODULO:
                            Modulo = "Repasse";
                            break;
                        case ACESSOS.ENTREGA_DE_CHAVES.ID_MODULO:
                            Modulo = "EntregaChaves";
                            break;
                        case 7:
                            Modulo = "PosOcupacional";
                            break;
                        case ACESSOS.HELPDESK.ID_MODULO:
                            Modulo = "HelpDesk";
                            break;
                        case ACESSOS.AUTOMACAO.ID_MODULO:
                            Modulo = "Automacao";
                            break;
                        default:
                            break;
                    }

                    return (
                        <Redirect
                            key={idModulo}
                            to={`/${Modulo}/${idModulo}`}
                        />
                    );
                }
                if (
                    idModulo &&
                    UserInfor.MODULOS?.find(
                        (mod) => mod.ID_MODULO === idModulo
                    ) === undefined
                ) {
                    return (
                        <Modal
                            show={show}
                            onHide={handleClose}
                            dialogClassName="modal-dialog modal-dialog-centered modal-xl"
                            aria-labelledby="contained-modal-title-vcenter"
                            centered
                        >
                            <Modal.Body className="card-body">
                                <h4>
                                    O seu usuário não tem permissões para
                                    acessar este módulo
                                </h4>
                            </Modal.Body>
                        </Modal>
                    );
                }
                if (idTela && telas !== true) {
                    return <div>Rota privada</div>;
                } else {
                    return <Component />;
                }
            }}
        />
    ) : (
        <Loading enable />
    );
};

export default PrivatedRoute;
